<edl-floating-label-container label="Search" [for]="inputId">
    <div class="input-group">
        <input
            [id]="inputId"
            type="text"
            class="form-control filter-by-search-by"
            placeholder="Search"
            [ngModel]="searchText"
            (ngModelChange)="onChange($event)"
            (blur)="onBlurEvent()"
            (click)="onTouchedCallback()"
            [disabled]="isDisabled"/>
        <button type="button"
            class="btn btn-secondary search-button"
            [ladda]="isBusy"
            [disabled]="isDisabled"
            (click)="onSearchButtonClicked()">
            <i class="fas fa-search"></i>
        </button>
    </div>
</edl-floating-label-container>
<paetep-reset-button *ngIf="onReset.observed"
    class="ms-2 d-inline-flex"
    (onClick)="onResetButtonClicked()"
    [isBusy]="isBusy"
    [isDisabled]="isDisabled"></paetep-reset-button>
